<template>
  <CommunityCard class="p-4">
    <form>
      <h3 class="text-inherit mb-4">Group Members</h3>

      <h4 class="mt-4">Invite Members</h4>
      <div class="d-flex dropdown-container">
        <input
          type="text"
          :class="{ 'form-control': true, 'is-invalid': invalidInvite }"
          style="width: 70%"
          v-model="inviteValue"
          placeholder="Enter email"
          aria-placeholder="Enter email"
        />
        <button
          class="btn btn-outline btn-primary flex-grow ml-2 d-lg-block"
          @click.prevent="sendInvites()"
        >
          <div style="display: flex; align-items: center">
            <i class="material-icons" style="margin-right: 7px">check</i>
            {{ inviteBtnText }}
          </div>
        </button>
      </div>

      <h5 class="mt-4">Owner</h5>
      <template v-if="ownerMember">
        <div class="member-2">o</div>
        <span class="ml-1">{{
          ownerMember.user.first_name + " " + ownerMember.user.last_name
        }}</span>
      </template>
      <div v-else>No owner</div>

      <h5 class="mt-4">Moderators</h5>
      <template v-if="moderatorMembers.length">
        <ul class="list-style-none">
          <li
            class="my-1"
            v-for="member in moderatorMembers"
            :key="member.user.id"
          >
            <div class="member-1">m</div>
            <span class="ml-1">{{
              member.user.first_name + " " + member.user.last_name
            }}</span>
          </li>
        </ul>
      </template>
      <div v-else>No moderators</div>

      <div class="d-flex dropdown-container">
        <v-select
          class="moderator-dropdown"
          label="name"
          :options="userMembers"
          multiple
          v-model="moderatorsToAdd"
        >
          <template #no-options>
            <em style="opacity: 0.5">No users found</em>
          </template>
          <template #header>
            <div style="opacity: 0.8">Assign moderators</div>
          </template>
        </v-select>

        <button
          class="btn btn-outline btn-primary flex-grow ml-2 d-lg-block"
          @click.prevent="selectModerators()"
        >
          <div style="display: flex; align-items: center">
            <i class="material-icons" style="margin-right: 7px">check</i>
            {{ moderatorBtnText }}
          </div>
        </button>
      </div>

      <h5 class="mt-4">Users</h5>
      <template v-if="userMembers.length">
        <ul class="list-style-none">
          <li class="my-1" v-for="member in userMembers" :key="member.id">
            <div class="member-0">u</div>
            <span class="ml-1">{{ member.name }}</span>
          </li>
        </ul>
      </template>
      <div v-else>No users</div>
    </form>
  </CommunityCard>
</template>

<script>
import forumGroupService from "../services/forumgroup.service";
import CommunityCard from "../components/CommunityCard";
import "vue-select/dist/vue-select.css";

const EMAIL_REGEX = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

export default {
  name: "ForumGroupMembers",
  props: ["groupMembers"],
  components: {
    CommunityCard,
  },
  data: function () {
    return {
      isSubmitting: false,
      moderatorBtnText: "Add Moderators",
      inviteBtnText: "Send Invite",
      moderatorsToAdd: [],
      inviteValue: "",
      invalidInvite: false,
    };
  },
  computed: {
    userMembers() {
      return this.groupMembers
        .filter((member) => member.member_type === 0)
        .map((member) => ({
          id: member.user.id,
          name: member.user.first_name + " " + member.user.last_name,
        }));
    },
    moderatorMembers() {
      return this.groupMembers.filter((member) => member.member_type === 1);
    },
    ownerMember() {
      return this.groupMembers.find((member) => member.member_type === 2);
    },
  },
  methods: {
    selectModerators() {
      if (this.isSubmitting || !this.moderatorsToAdd.length) return;
      this.isSubmitting = true;

      this.moderatorBtnText = "...";

      const flatModerators = this.moderatorsToAdd.map((m) => m.id);

      forumGroupService
        .addModerators(this.$route.params.groupId, flatModerators)
        .then(() => {
          this.$emit("success", "Your changes have been saved.");
        })
        .finally(() => {
          this.$emit("reload");
          this.moderatorBtnText = "Add Moderators";
          this.isSubmitting = false;
          this.moderatorsToAdd = [];
        });
    },
    sendInvites() {
      if (this.isSubmitting) return;

      this.inviteValue = this.inviteValue.trim();
      if (!EMAIL_REGEX.test(this.inviteValue)) {
        this.invalidInvite = true;
        return;
      }

      this.isSubmitting = true;
      this.invalidInvite = false;
      this.inviteBtnText = "...";

      forumGroupService
        .inviteUsers(this.$route.params.groupId, this.inviteValue)
        .then(() => {
          this.$emit("success", "Invite sent.");
        })
        .finally(() => {
          this.inviteBtnText = "Send invite";
          this.isSubmitting = false;
        });
    },
  },
};
</script>

<style scoped>
.dropdown-container {
  width: 100%;
  align-items: flex-end;
}

.moderator-dropdown .vs__search::placeholder,
.moderator-dropdown .vs__dropdown-toggle {
  width: 100%;
  height: 38px;
}
.v-select {
  width: 70%;
}

.member-0,
.member-1,
.member-2 {
  border-radius: 3px;
  padding: 2px 4px;
  display: inline-block;
  width: 25px;
  text-align: center;
  color: white;
}
.member-0 {
  background: #014a8f;
}
.member-1 {
  background: #28a745;
}
.member-2 {
  background: #ff9817;
}
</style>
